import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=674f0e47&"
import script from "./DetailDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports